import { CampaignUpdatePayload, MeasurementUpdatePayload } from '../types/websocket.types';

/** A measurement-update broadcast targets a campaign when it names it directly or
 *  carries it in a batch — a formula edit fans out to every campaign using the
 *  measure in a single push. */
export function measurementUpdateTargetsCampaign(payload: MeasurementUpdatePayload, campaignId: number | null | undefined): boolean {
  if (campaignId == null) return false;
  return payload.campaignId === campaignId || (payload.campaignIds?.includes(campaignId) ?? false);
}

/** A measurement-update broadcast targets a measure when the payload names it —
 *  directly (manual value edits, calculation completion), or in the measureIds
 *  fan-out a pending frame carries for the analysis posts whose formulas
 *  reference the recomputing measure. */
export function measurementUpdateTargetsMeasure(payload: MeasurementUpdatePayload, measureId: number | null | undefined): boolean {
  if (measureId == null) return false;
  return payload.measureId === measureId || (payload.measureIds?.includes(measureId) ?? false);
}

/** A measurement-update broadcast targets an asset-scoped screen when it names that asset.
 *  Every calc/edit broadcast carries assetId, so an asset-wide grid (the monitoring Tables
 *  view spans many measures/campaigns) refreshes on any change under the asset it displays —
 *  the measure/campaign buckets alone would each miss the other. */
export function measurementUpdateTargetsAsset(payload: MeasurementUpdatePayload, assetId: number | null | undefined): boolean {
  if (assetId == null) return false;
  return payload.assetId === assetId;
}

/** A campaign-update broadcast targets an asset-scoped screen (the campaigns list) when it
 *  names that asset — every campaign status/conflict/import transition carries assetId. */
export function campaignUpdateTargetsAsset(payload: CampaignUpdatePayload, assetId: number | null | undefined): boolean {
  if (assetId == null) return false;
  return payload.assetId === assetId;
}

/** A campaign-update broadcast targets a single campaign's detail screen when it names it —
 *  directly (campaignId) or within a batched bulk-import push (campaignIds). */
export function campaignUpdateTargetsCampaign(payload: CampaignUpdatePayload, campaignId: number | null | undefined): boolean {
  if (campaignId == null) return false;
  return payload.campaignId === campaignId || (payload.campaignIds?.includes(campaignId) ?? false);
}
